import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { platforms } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-foreground-950">嫩草视频</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              嫩草视频聚合妖精视频、桃花视频、苹果视频、榴莲视频、豆花视频等平台热播影视剧，提供最新电视剧完整版高清在线观看，电影大全每日更新，追剧不等待。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-colors">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <Link to="/category/reboju" className="hover:text-primary-500 transition-colors">视频分类</Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">合作平台</h4>
            <ul className="space-y-2.5">
              {platforms.map((p) => (
                <li key={p.id}>
                  <span className="text-sm text-foreground-600">{p.name}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <Link to="/about" className="hover:text-primary-500 transition-colors">关于我们</Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">品牌介绍</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">用户口碑</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">联系方式</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 嫩草视频 nencao.com. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}